import { Grid } from '@mui/material';

import FormControlledSelect from './FormControlledSelect';
import FormControlledTextField from './FormControlledTextField';

type EditLocationFormProps = {
  includeStatus?: boolean;
};

export default function EditLocationForm({ includeStatus = true }: EditLocationFormProps) {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="name"
          label="Location Name"
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <FormControlledTextField
          name="addressLine1"
          label="Address Line 1"
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="city"
          label="City"
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="province"
          label="Province"
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="postalCode"
          label="Postal Code"
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="country"
          label="Country"
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="phone"
          label="Phone"
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="email"
          label="Email"
          variant="outlined"
          fullWidth
        />
      </Grid>
      {includeStatus && (
        <Grid size={{ xs: 12 }}>
          <FormControlledSelect
            name="isDisabled"
            label="Status"
            variant="outlined"
            data={[
              { label: 'Enabled', value: 'false' },
              { label: 'Disabled', value: 'true' },
            ]}
            fullWidth
          />
        </Grid>
      )}
    </Grid>
  );
}
